<template>
    <section class="step-indicator-container">
        <p class="mb-2">
            {{ $l10n.__("Etape %(currentStep)s sur %(nbStep)s", {currentStep: currentStepNumber, nbStep: nbStep}) }}
        </p>
        <ul class="m-0 flex-level">
            <li v-for="index in nbStep" :key="index" class="step-indicator" :class="{'active': index <= currentStepNumber}"></li>
        </ul>
    </section>
</template>

<script>
export default {
    name: 'StepperIndicator',
    props: {
        nbStep: {
            type: Number,
            required: true,
        },
        currentStepNumber: {
            type: Number,
            required: true,       
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';
    @import '~@sellsy/styleguide/src/_mixins';

    $animate: all 300ms ease-in-out;

    .step-content-container {
        max-width: 1280px;
    }

    .step-indicator-container {
        display : flex;
        flex-direction : column;
        align-items : center;
        padding-bottom : spacer(4);
    }

    .step-indicator {
        width: 48px;
        height: 3px;
        border-radius: 4px;
        background: $primary-05;
        margin-right: spacer(1);
            &:before,
            &:after {
                content: "";
                position: absolute;
                width: 0px;
                height: 3px;
                transition: $animate;
                background-color: $primary-50;
            }
        &.active {
            &:before,
            &:after {
                width: 48px;
                transition: $animate;
                background-color: $primary-50;
            }
        }
    }
</style>
